import styled from 'styled-components'
import { Link } from 'react-router-dom'
import color from 'sidecar-theme/lib/color'
import {BodyContent as BaseBodyContent} from 'sidecar-ui/lib/layout'

export const BodyContent = styled(BaseBodyContent)`
  height: 100%;
`

export const Panel = styled.div`
  background: white;
  width: 46rem;
  border: 1px solid ${color.SILVER};
  border-radius: 1rem;
  background: ${color.WHITE};
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.25);
  margin: 4rem auto 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &:not(:last-child) {
    margin-bottom: 30px;
  }
`

export const PanelBody = styled.div`
  flex-grow: 9;
  padding: 3rem;

  h1 {
    margin-top: 0;
  }
`

export const PanelFooter = styled.div`
  flex-grow: 1;
  line-height: 2.5rem;
  text-align: center;
  background: ${color.SMOKE};
  border-top: solid 1px ${color.SILVER};
  padding: 3rem;
  max-height: 9rem;

  a {
    color: #64c5af;

    &:hover {
      color: #2c949a;
    }
  }
`

export const ForgotBtn = styled(Link)`
  padding: 10px;
  text-align: center;
  width: 100%;
`

export const LoginWarning = styled.div`
  width: 46rem;
  margin: 4rem auto 0;
  overflow: hidden;
`



// WEBPACK FOOTER //
// ./src/pages/Login/styles.js